import { Component, OnInit } from '@angular/core';
import {Router} from "@angular/router";
import {AuthService} from "../../auth/auth.service";

@Component({
  selector: 'nuc-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent implements OnInit {
  isOpen: boolean = false;
  constructor(public _router: Router, private authService: AuthService) { }

  ngOnInit() {
    //this.getUserProfile();
  }
 getUserProfile(){
    this.authService.getProfileSubject()
      .subscribe((response)=>{console.info(response)})
 }
}



// WEBPACK FOOTER //
// ./src/app/shared/navigation/navigation.component.ts